var app = {
  isShowTodoDetail: false,
  todoItem: {},
  highlightTask: "",
  listContactsAccount: [],
  expandMessage: true,
  allGroupIds: new Map(),
  characterFilters: {},
  conversationIdForCRM: "",
  switchCRM: false,
  draftMessageList: {},
  listDraft: new Map(),
  loginZalo: "/setting",
  showExpiresPopup: true,
  saleworkApi: {
    initData: "https://stock.salework.net/api/getInitData",
    addressCode: "https://stock.salework.net/api/getAddressCode",
    order: "https://stock.salework.net/api/order",
    customer: "https://stock.salework.net/api/customer",
    shipping: "https://stock.salework.net/api/3rd_logistic"
  },
  aliases: [],
  selectedConversation: {},
  selectedConversationMessage: {},
  selectedConv: {},
  logged_in_user: {
    avatar: "",
    type: "",
    company: {
      name: "",
      code: "",
      alias: "",
      avatar: ""
    },
    admin: false,
    username: "",
    fullName: "",
    role: "",
    permissions: []
  },
  accounts: [],
  accountsZaloContact: [],
  vue: undefined,
  navbarExpanded: false,
  conversations: [],
  user: {},
  sessionId: "",
  permissions: [],
  shopLimit: 0,
  staffLimit: 0,
  shops: [],
  localData: {},
  loading: false,
  navigation: {
    visible: false,
    transition: "",
    stack: []
  },
  quickReplyList: [],
  accountSetting: [],
  tags: [],
  isSkipTour: false,
  restDay: 0,
  paymentType: "",
  zaloNotify: false,
  shopExpired: false,
  tagAssignMe: [],
  tagAssign: [],
  showAllContact: false,
  showPhoneInContact: false,
  iconType: [
    { type: "xlsx", url: "https://chat.zalo.me/assets/icon-excel.fe93010062660a8332b5f5c7bb2a43b1.svg" },
    { type: "video", url: "https://chat.zalo.me/assets/icon-video.651f286c9db0a8e1125cee5fd01269ba.svg" },
    { type: "pdf", url: "https://chat.zalo.me/assets/icon-pdf.53e522c77f7bb0de2eb682fe4a39acc3.svg" },
    { type: "zip", url: "https://chat.zalo.me/assets/icon-zip.e1e9b9936e66e90d774fcb804f39167f.svg" },
    { type: "word", url: "https://chat.zalo.me/assets/icon-word.d7db8ecee5824ba530a5b74c5dd69110.svg" },
    { type: "html", url: "https://chat.zalo.me/assets/icon-html.85ad6684ba36beffff13ee693c717729.svg" },
    { type: "word", url: "https://chat.zalo.me/assets/icon-word.d7db8ecee5824ba530a5b74c5dd69110.svg" }
  ],
  verified: false,
  contactTotal: {
    all: 0,
    contact: 0,
    swContact: 0,
    recommend: 0,
    log: 0
  },
  isComponentMessageOpen: false,
  selectedImages: [],
  colorOrder: {
    "TẤT CẢ": "#28a745",
    "CHỜ XÁC NHẬN": "#6c757d",
    "KIỂM KÊ": "#6c757d",
    "CHỜ HÀNG": "#6c757d",
    MỚI: "#007bff",
    "HẸN GIAO": "#007bff",
    "CHỜ ĐÓNG GÓI": "#17a2b8",
    "ĐANG ĐÓNG GÓI": "#17a2b8",
    "CHỜ GỬI HÀNG": "#17a2b8",
    "ĐÃ GỬI HÀNG": "#ffc107",
    "ĐANG GIAO": "#ffc107",
    "THÀNH CÔNG": "#28a745",
    HOÀN: "#dc3545",
    "THẤT THU": "#dc3545",
    HỦY: "#dc3545"
  },
  pinConversations: [],
  pinConversationView: [],
  stickerMap: new Map(),
  replaceLink: [],
  sendByList: [],
  reactionList: [],
  customerCodeList: [],
  ccode: "",
  cToken: "",
  loginV2: false,
  stickerInfor: [],
  logInAt: new Date().getTime(),
  pointConversation: new Map(),
  aiService: "none",
  messageQueue: [],
  downloadedMessageIds: new Set(),
  cloudSettingCache: [],
  hasQuota: true,
  emptyAccountIds: new Set(),
  loadingPendingMessages: false
};
export { app };
